import React, { FC } from 'react'
import { ItemProps } from '../../types'
import ValidationError from '../ValidationError'


const Text: FC<ItemProps> = (
	{
		formItem,
		validation,
		disabled,
		formData,
		onChange,
		onFocus,
		onBlur,
		onKeyDown,
		autoFocus,
	},
) => {

	return (
		<>
			<input
				name={formItem.name}
				type={formItem.type}
				placeholder={formItem.placeholder}
				disabled={disabled}
				className={`transition-all outline-none
                    ${formItem.disabled ? 'disabled' : ''}
                    w-full text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
                    placeholder:text-gray-400 placeholder:text-text-md
                    focus:shadow-focus focus:border-primary-500
                    hover:border-primary-500 shadow-xs
                    h-[44px] px-md
                    
                    ${formItem.classNames?.content || ''}
                    ${validation ? 'border-red-500 border-2 focus:border-red-600 focus:shadow-red hover:border-red-600' : ''}
                `}
				autoComplete="off"
				value={formData[formItem.name] || ''}
				onChange={(e) => onChange?.(formItem.name, e.target.value)}
				onFocus={onFocus}
				onBlur={onBlur}
				onKeyDown={onKeyDown}
				autoFocus={autoFocus}
			/>
			<ValidationError error={validation} formItem={formItem} />
		</>
	)
}

export default Text
